import React from 'react'
import { AppBar } from '@atd/rui-base.mui.app-bar'
import { Toolbar } from '@atd/rui-base.mui.toolbar'
import { Typography } from '@atd/rui-base.mui.typography'
import { IconButton } from '@atd/rui-base.mui.icon-button'
import CloseIcon from '@mui/icons-material/Close'

export default function DialogHeader({ children, onClose }) {
    return (
        <AppBar position="static" elevation={0} sx={{backgroundColor: 'var(--primary)'}}>
            <Toolbar>
                <Typography variant="h6" sx={{flexGrow: 1}}>{children}</Typography>
                <IconButton onClick={onClose} aria-label="close" color="inherit" edge="end">
                    <CloseIcon />
                </IconButton>
            </Toolbar>
        </AppBar>
    )
}
